import { Box, Typography } from "@mui/material"

export default function DisplayEmptyListAction({
    label,
    actionSection = null,
    disabled = false
}: DisplayEmptyListActionProps) {

    return (
        <Box
            p={3}
            gap={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            border={`1px dashed ${disabled ? "gray" : "#1B5E20"}`}
            borderRadius={1}
            flexDirection="column"
        >
            <Typography textAlign="center" color={disabled ? "gray" :"primary"} variant="caption">{label}</Typography>

            {
                Boolean(actionSection) &&
                <Box>
                    {actionSection}
                </Box>
            }
        </Box>
    )
}

interface DisplayEmptyListActionProps {
    label: string,
    disabled?: boolean,
    actionSection?: JSX.Element | null
}